import axios from "axios";

const baseReq = axios.create({
  timeout: 8000
});

baseReq.interceptors.response.use(res => {
  if (res.data.code === 200) {
    return res.data.data;
  } else {
    return Promise.reject(res.data.msg);
  }
});

/**
 * 生成短链接
 * @param data 
 */
export const generateShortUrl = (data) => {
  return baseReq.post('//tbk.aiduoka.com/api/v1/taobao/tkl/tbk-tkl-shorturl',data, {
    jsonType: true
  });
}
